import React from "react";
import { Modal, Button, Form, ListGroup } from "react-bootstrap";

export default function ApplicationMessagesModal({
  show,
  onHide,
  activeAppMsg,
  appMsgThread,
  appMsgLoading,
  appMsgText,
  setAppMsgText,
  appMsgError,
  handleSendAppMsg
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Messages for {activeAppMsg?.course || "Application"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 400, overflowY: 'auto' }}>
        {appMsgLoading ? (
          <div className="text-muted px-3 py-2">Loading messages...</div>
        ) : appMsgThread.length === 0 ? (
          <div className="text-muted">No messages yet.</div>
        ) : (
          <ListGroup variant="flush" style={{ maxHeight: 280, overflowY: 'auto', borderRadius: 8 }}>
            {appMsgThread.map((msg, idx) => (
              <ListGroup.Item key={idx}>
                <div>
                  <b style={{ color: msg.from === "student" ? "#2d4596" : "#10804f" }}>
                    {msg.from === "student" ? "You" : "Institute"}
                  </b>: {msg.text}
                </div>
                <div className="text-muted small">{msg.date && (new Date(msg.date)).toLocaleString()}</div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}

        <Form.Group className="mt-3">
          <Form.Control
            as="textarea"
            rows={2}
            value={appMsgText}
            placeholder="Type your reply..."
            onChange={e => setAppMsgText(e.target.value)}
            disabled={appMsgLoading}
          />
        </Form.Group>
        {appMsgError && <div className="text-danger mt-2">{appMsgError}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSendAppMsg}
          disabled={!appMsgText.trim() || appMsgLoading}
        >
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
